import { FC } from 'react';

import { MICROCOPY } from '@/data/microcopy/microcopyDictionary';
import { BasicModal } from '@/general/components/BasicModal/BasicModal';
import { Button } from '@/general/components/Button/Button';
import { getMicrocopyBulk } from '@/stores/microcopyStore';

export interface VisaIssuesFormProps {
  isOpen: boolean;
  backToHome: () => void;
}

export const VisaIssuesForm: FC<VisaIssuesFormProps> = ({ isOpen, backToHome }) => {
  const { title, content, buttonLabel } = getMicrocopyBulk({
    title: [MICROCOPY.CHECKOUT_FINANCE_QUOTE_MODAL_VISA_ISSUES_TITLE],
    content: [MICROCOPY.CHECKOUT_FINANCE_QUOTE_MODAL_VISA_ISSUES_CONTENT],
    buttonLabel: [MICROCOPY.CHECKOUT_FINANCE_QUOTE_MODAL_VISA_ISSUES_BUTTON_LABEL],
  });

  return (
    <BasicModal
      id="visa-issues-modal"
      title={title}
      className="md:min-w-xl"
      isOpen={isOpen}
      onClose={backToHome}
      footer={<Button onClick={backToHome}>{buttonLabel}</Button>}
    >
      {content}
    </BasicModal>
  );
};
